<script>
    import { navigate } from "svelte-routing"
    import { parseDate } from '../../shared/utils.js'
    import * as api     from '../../shared/api.js'
    import Copy         from '../../shared/Copy.svelte'

    export let dragged = false
    export let item

    function viewItem() {
        navigate(`/empresa/${item.inquiry.domain.company}/pedidos/${item.inquiry.domain.domain}/pedido/${item.inquiry.protocol}`)
    }

    function titleOf(item) {
        return `[${item.inquiry.protocol.substring(0, 5)}] ${scopeOf(item)}`
    }

    function scopeOf(item) {
        switch(item.inquiry.scope) {
            case 'SAR': return 'Pedido de Acesso'
            case 'DDR': return 'Pedido de Remoção'
            default   : return 'Pedido desconhecido'
        }
    }

    function iconOf(item) {
        switch(item.inquiry.status) {
            case 'CREATED'          : return 'hand spock   yellow icon'
            case 'DENIED'           : return 'ban          red    icon'
            case 'IDENTIFIED'       : return 'user         blue   icon'
            case 'ON HOLD'          : return 'pause        grey   icon'
            case 'EXECUTING'        : return 'play         olive  icon'
            case 'GENERATING REPORT': return 'sync loading green  icon'
            case 'REPORT SUCCESS'   : return 'certificate  green  icon'
            case 'REPORT AVAILABLE' : return 'download     green  icon'
            case 'REPORT ERROR'     : return 'circle       red    icon'
            default                 : return null
        }
    }

    $: icon = iconOf(item)
   
</script>
<style>
    .item {
        cursor: move;
    }

    .top {
        display: flex;
        margin-bottom: .4em;
    }

    .title {
        font-size: 13pt;
        font-weight: 700;
        cursor: pointer;
    }

    .date {
        color: #ccc;
    }

    .dragged {
        opacity: 70%;
    }
</style>
<div class="ui raised segment item" class:dragged>
    <div class="top">
        <span class="title" on:click={ viewItem }>{ item.inquiry.protocol.substring(0, 5) }</span>
        <span style="flex: 1"></span>
        {#if icon}
            <i class="{ icon }"/>
        {/if}
    </div>
    <div>{ scopeOf(item) }</div>
    <div class="date">{ parseDate(item.inquiry.created) }</div>
</div>